import { Observer } from "mobx-react";
import { useState } from "react";
import { useStores } from "../../store";
export default function HeaderAnswer(props) {
  const { MockStore } = useStores();
  const [selectedNumber, setSelectedNumber] = useState(1);
  const numbers = [];
  for (let i = 1; i <= props.totalQue; i++) {
    numbers.push(i);
  }
  //   useEffect(() => {console.log("number:",1===selectedNumber);}, [selectedNumber]);
  return (
    <Observer>
      {() => {
        return (
          <div>
            <div className="flex md:flex-row lg:flex-row flex-col tc6:flex-row justify-between  p-2  items-center rounded-lg ">
              <span className="text-primary font-semibold md:mr-0 lg:mr-0 mr-48 text-xl">
                Answer Key
              </span>
              <div className="flex flex-row md:gap-0 lg:gap-0 gap-6 justify-center items-center ">
                <label
                  className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                  htmlFor="gender"
                >
                  <select
                    className="border-2 border-primary  focus:outline-none  pl-3 mt-1 h-10 lg:h-16 rounded-lg w-56 lg:w-60"
                    value={MockStore.section}
                    onChange={(e) => {
                      if (e.target.value === "CORE") {
                        const branch = localStorage.getItem("branch");
                        MockStore.setSection("CORE");
                      } else {
                        MockStore.setSection(e.target.value);
                      }
                      MockStore.setQuestionNumber(1);
                    }}
                    required
                  >
                    <option value="APTITUDE">Aptitude</option>
                    <option value="REASONING">Reasoning</option>
                    <option value="VERBAL">Verbal</option>
                    <option value="CORE">Core Subject</option>
                  </select>
                </label>
                <span className="bg-primary text-white py-5 px-4 rounded-full md:mr-0 lg:mr-0 mr-2">
                  {props.visitedQue}/{props.totalQue}
                </span>
              </div>
            </div>
            <div className="grid grid-col-5 md:flex md:flex-col w-[100%] px-5 pt-2">
              {numbers
                .reduce((rows, number, index) => {
                  if (index % 20 === 0) rows.push([]);
                  rows[rows.length - 1].push(number);
                  return rows;
                }, [])
                .map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className={`grid grid-cols-4 gap-2 md:flex py-1 md:flex-row md:items-center ${
                      row.length !== 20 ? "md:gap-2" : "md:justify-between"
                    }`}
                  >
                    {row.map((number) => (
                      <div
                      key={number}
                      className={`md:py-2 md:px-3.5 w-10 h-10 flex items-center justify-center text-gray-400 border cursor-pointer border-gray-400 rounded-full ${
                        Number(number) === Number(MockStore.questionNumber)
                          ? "text-primary border-primary"
                          : ""
                      }`}
                      onClick={() => {
                        MockStore.setQuestionNumber(number);
                        console.log(MockStore.currentQuestionNumber);
                      }}
                    >
                      {number}
                    </div>
                    
                    ))}
                  </div>
                ))}
            </div>
          </div>
        );
      }}
    </Observer>
  );
}
